<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->


<app-generic-modal (primaryActionEvent)="save()"
                   [primaryActionEnabled]="isValid"
                   [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #name
                        (inputValueChange)="nameInputChange($event)"
                        [messages]="nameMessages"
                        [validators]="validators.name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-partner-modal-name"
                        label="Partner name"
                        maxLength="100"
                        placeholder="Please, write a new partner name"></app-input-text>
        <app-input-text #code
                        (inputValueChange)="codeInputChange($event)"
                        [messages]="codeMessages"
                        [validators]="validators.code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-partner-modal-code"
                        label="Partner code number"
                        maxLength="10"
                        placeholder="Please, write a new partner code number, e.g. 1300049288"></app-input-text>
        <app-input-text #sequencer
                        (inputValueChange)="sequencerInputChange($event)"
                        [labelInformation]="sequencerInformation"
                        [messages]="sequencerMessages"
                        [validators]="validators.sequencer"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-partner-modal-sequencer"
                        label="Partner sequencer"
                        maxLength="2"
                        placeholder="Please, write a new partner sequencer, e.g. 05"></app-input-text>

        <ng-template #sequencerInformation>
            <app-tooltip
                    [orderedList]="false"
                    [tooltipType]="TooltipEnum.INFORMATION"
                    class="display-inline-flex vertical-align-baseline"
                    message="Partner sequencer are the first two digits of a SPO number or a CLAIM number for a specific Partner."
                    placement="right"></app-tooltip>
        </ng-template>

        <div class="partner-parent-info-section">
            <div class="modal-info-label">Associated country alphacode 3</div>
            <div class="modal-info-value"
                 data-cy="business-settings-partner-parent-info">{{$safeNavigationMigration(state?.originalElement?.displayParentCode) | undefinedValue}}</div>
        </div>

        <app-active-input (checkState)="setActiveInputState($event)" [entityName]="ENTITY_NAME"
                          [state]="$safeNavigationMigration(state?.isActive)"></app-active-input>
    </div>
</app-generic-modal>
